import React from 'react';
import { graphql } from "gatsby";
import SEO from "../../components/seo/Seo";
import Header from "./../../components/headers/Header";
import Footer from "../../components/layouts/Footer";
import FluorescenceDescription from "../../components/fluorescence/FluorescenceDescription";
import FluorescenceGallery from "../../components/fluorescence/FluorescenceGallery";
import CallToAction from "../../components/layouts/CallToAction";
import FluorescenceGoodToKnow from "../../components/fluorescence/FluorescenceGoodToKnow";
import FluorescenceHeader from "../../components/fluorescence/FluorescenceHeader";

function RudniskaFlorescenca({data}) {
    return (
        <>
            <SEO title="Rudniška fluorescenca" description="Doživi skrivnostno moč podzemlja na povsem drugačen način! Sprehod v rudniku je vodena izkušnja v rovih, kjer se s pomočjo UV-svetilk podate na čutno in vizualno raziskovanje čudovitih mineralnih struktur in drugih presenečenj pod zemljo." />
            <Header />
            <FluorescenceHeader/>
            <FluorescenceDescription/>
            <FluorescenceGoodToKnow/>
            <FluorescenceGallery imagesData={data.source.edges}/>
            <CallToAction/>
            <Footer/>
        </>
    );
}

export const pageQuery = graphql`
    query ImagesForFluorescenceGallery {
        source: allFile(filter: {relativePath: {regex: "rudnik/rudniska-florescenca-galerija/"}}) {
            edges {
                node {
                    childImageSharp {
                        thumb: gatsbyImageData(
                            width: 200
                            height: 200
                            placeholder: BLURRED
                        )
                        full: gatsbyImageData(layout: FULL_WIDTH)
                    }
                }
            }
        }
    }
`;

export default RudniskaFlorescenca;
